import type { ISEOProps } from "../types/core";

export const HomePageSEO: ISEOProps = {
  title: "Sugar Cribs",
  description: "Sugar Cribs is a platform for sharing and discovering content.",
};
